import React from 'react';
import { Card, CardContent } from '../ui/card';

const SkeletonInsightCard = () => (
  <Card className="hover:shadow-xl transition-shadow duration-300">
    <CardContent className="p-6">
      {/* Badge skeleton */}
      <div className="h-6 bg-gray-200 rounded-full w-24 mb-4 animate-pulse" />
      
      {/* Title skeleton */}
      <div className="h-6 bg-gray-200 rounded w-full mb-3 animate-pulse" />
      <div className="h-6 bg-gray-200 rounded w-3/4 mb-4 animate-pulse" />
      
      {/* Excerpt skeleton */}
      <div className="space-y-2 mb-4">
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse" />
        <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse" />
      </div>
      
      {/* Meta info skeleton */}
      <div className="flex items-center justify-between pt-4 border-t">
        <div className="flex items-center space-x-4">
          <div className="h-4 bg-gray-200 rounded w-24 animate-pulse" />
          <div className="h-4 bg-gray-200 rounded w-20 animate-pulse" />
        </div>
        <div className="h-4 bg-gray-200 rounded w-16 animate-pulse" />
      </div>
    </CardContent>
  </Card>
);

const SkeletonFeaturedInsight = () => (
  <Card className="mb-12 overflow-hidden">
    <CardContent className="p-8 md:p-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Image skeleton */}
        <div className="w-full h-64 bg-gray-200 rounded-lg animate-pulse" />
        
        {/* Content skeleton */}
        <div className="flex flex-col justify-center">
          <div className="h-6 bg-gray-200 rounded-full w-32 mb-4 animate-pulse" />
          <div className="h-8 bg-gray-200 rounded w-full mb-3 animate-pulse" />
          <div className="h-8 bg-gray-200 rounded w-4/5 mb-6 animate-pulse" />
          
          <div className="space-y-2 mb-6">
            <div className="h-4 bg-gray-200 rounded w-full animate-pulse" />
            <div className="h-4 bg-gray-200 rounded w-full animate-pulse" />
            <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse" />
          </div>
          
          <div className="flex items-center space-x-6 mb-6">
            <div className="h-4 bg-gray-200 rounded w-24 animate-pulse" />
            <div className="h-4 bg-gray-200 rounded w-20 animate-pulse" />
          </div>
          
          <div className="h-10 bg-gray-200 rounded w-32 animate-pulse" />
        </div>
      </div>
    </CardContent>
  </Card>
);

export const InsightsSkeletonLoader = () => (
  <div className="min-h-screen pt-20">
    {/* Hero skeleton */}
    <section className="relative py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="h-12 bg-gray-700 rounded w-2/3 mx-auto mb-6 animate-pulse" />
          <div className="h-6 bg-gray-700 rounded w-1/2 mx-auto mb-8 animate-pulse" />
          
          {/* Search skeleton */}
          <div className="max-w-md mx-auto">
            <div className="h-12 bg-gray-700 rounded-lg animate-pulse" />
          </div>
        </div>
      </div>
    </section>

    {/* Content skeleton */}
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Featured article skeleton */}
        <SkeletonFeaturedInsight />
        
        {/* Category filters skeleton */}
        <div className="flex flex-wrap gap-3 mb-12">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="h-10 bg-gray-200 rounded-full w-28 animate-pulse" />
          ))}
        </div>
        
        {/* Articles grid skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[...Array(6)].map((_, i) => (
            <SkeletonInsightCard key={i} />
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default InsightsSkeletonLoader;
